import './App.css';
import Home from "./components/Home";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Resume from "./components/Resume";
import { BlogListPage, BlogPostPage } from "./blog";
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route path="/resume" element={<Resume/>} />
          <Route path="/blog" element={<BlogListPage/>} />
          <Route path="/blog/:slug" element={<BlogPostPage/>} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
